import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "assets/scss/dashboard.scss";
import "assets/css/charts_form_controls.css";
import "assets/css/grid_table.css";
import numeral from "numeral";
import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import Select from "react-select";
import { Divider } from "primereact/divider";
import moment from "moment";
import { getDataApi, saveApi, loadApi } from "services/appApi";
import { pecaPageRows, pecaRowsPerPageOptions } from "pages/common/envPECA";
import axios from "axios";
import { set } from "date-fns";

const ShiftTypes = () => {
  let emptyRow = {
    user_id: null,
    auto_shift_close_flag:"",
    auto_shift_close_flag_disp: "",
    auto_shift_open_flag: "",
    auto_shift_open_flag_disp: "",
    end_date_active: null,
    process_name: "",
    shift_early_end_allow_mins: 60,
    shift_early_start_allow_mins: 60,
    shift_late_end_allow_mins: 60,
    shift_late_start_allow_mins: 60,
    shift_type_id: null,
    shift_type_name: "",
    start_date_active: ""
  };
  let emptyDetailRow = {
    auto_shift_close_flag_disp: "",
    auto_shift_open_flag_disp: "",
    end_date_active: null,
    shift_early_end_allow_mins: null,
    shift_early_start_allow_mins: null,
    shift_end_in_next_day_flag_dsp: "",
    shift_end_time: "",
    shift_late_end_allow_mins: null,
    shift_late_start_allow_mins: null,
    shift_number: null,
    shift_start_time: "",
    shift_type_detail_id: null,
    start_date_active: ""
  };

  /**** 31-May-2024 Velmani P. Following changes are made to template
   * 	a. Use a generic name "row" instead of "product".  Following are the name changed from template
   * 	   a1. products ==> rows
   * 		[products, setProducts] ==> [products, setRows]
   * 		[deleteProductsDialog, setDeleteProductsDialog] ==> [deleteRowsDialog, setDeleteRowsDialog]
   * 		[selectedProducts, setSelectedProducts] ==> [selectedRows, setSelectedRows]
   * 	   a2. product  ==> row
   *		[productDialog, setProductDialog] ==> [productDialog, setRowDialog]
   *		[deleteProductDialog, setDeleteProductDialog] ==> [deleteRowDialog, setDeleteRowDialog]
   *		[product, setProduct] ==> [product, setRow]
   * ******/
  const [rows, setRows] = useState([]);
  const [rowDialog, setRowDialog] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [detailRow, setDetailRow] = useState(emptyDetailRow);
  const [selectedRows, setSelectedRows] = useState(null);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [showDetailDialog, setShowDetailDialog] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [dialog, setDialog] = useState("");
  const [globalFilter1, setGlobalFilter1] = useState(null);
  const [wasDataFetchingSuccessful, setWasDataFetchingSuccessful] = useState(true);
  const [shiftTemplateId, setShiftTemplateId] = useState({label: "", value: null});
  const [processSelectId, setProcessSelectId] = useState({label: "", value: null});
  const [processNameId, setProcessNameId] = useState({label: "", value: null});
  const [shiftTypeSelectId, setShiftTypeSelectId] = useState({label: "", value: null});
  const [sortKey, setSortKey] = useState(null);
  const [startDate, setStartDate] = useState();
  const [expandedRowId, setExpandedRowId] = useState([]);
  const [isLoading1, setIsLoading1] = useState(false);
  const [endDate, setEndDate] = useState();
  const [shiftDetail, setShiftDetail] = useState({});
  const [fetchShiftTemplates, setFetchShiftTemplates] = useState(true);
  const [fetchYesOrNoLOV, setFetchYesOrNoLOV] = useState(true);
  const [fetchProcess, setFetchProcess] = useState(true);
  const [shiftTemplates, setShiftTemplates] = useState([]);
  const [loadingRowId, setLoadingId] = useState(null);
  const [shiftOpenFlagId, setShiftOpenFlagId] = useState({label: "", value: ""});  
  const [shiftCloseFlagId, setShiftCloseFlagId] = useState({label: "", value: ""});
  const [shiftOpenSelectFlagId, setShiftOpenSelectFlagId] = useState({label: "", value: ""});
  const [shiftCloseSelectFlagId, setShiftCloseSelectFlagId] = useState({label: "", value: ""});
  const [shiftOpenFlag, setShiftOpenFlag] = useState([]);
  const [shiftCloseFlag, setShiftCloseFlag] = useState([]);
  const [processName, setProcessName] = useState([]);
  const dt1 = useRef(null);
  const toast = useRef(null);
  const dt = useRef(null);
  const prevExpanRef = useRef([])

  useEffect(() => {
        const fetchShiftTemplates = async () => {
          setFetchShiftTemplates(true);
          try {
            let res = await getDataApi("/api/setup/shiftTypes/shiftTempLOV");
            if (res) {
              let successFlag = res.data[0];
              console.log("Response: ",res);
              console.log("Success Flag",successFlag);
              if (successFlag === "Y" && Array.isArray(res.data[1])) {
                const options= res.data[1].map((item)=>({
                  label: item.shift_type_name,
                  value: item.shift_type_id
                }))
                setShiftTemplates(options)
                setFetchShiftTemplates(false);
              } 
            }
          } catch (err) {
            console.log(err);
            setFetchShiftTemplates(false);
          }
        };
        fetchShiftTemplates();
      }, []);

      useEffect(() => {
        const fetchProcess = async () => {
          setFetchProcess(true);
          try {
            let res = await getDataApi("/api/setup/shiftTypes/processLOV");
            if (res) {
              let successFlag = res.data[0];
              console.log("Process Response: ",res);
              console.log("Success Flag",successFlag);
              if (successFlag === "Y" && Array.isArray(res.data[1])) {
                const options= res.data[1].map((item)=>({
                  label: item.process_name,
                  value: item.process_id
                }))
                setProcessName(options)
                setFetchProcess(false);
              } 
            }
          } catch (err) {
            console.log(err);
            setFetchProcess(false);
          }
        };
        fetchProcess();
      }, []);

      useEffect(() => {
        const fetchYesOrNoLOV = async () => {
          setFetchYesOrNoLOV(true);
          try {
            let res = await getDataApi("/api/setup/shiftTypes/yesOrNoLOV");
            if (res) {
              let successFlag = res.data[0];
              console.log("Response: ",res);
              console.log("Success Flag",successFlag);
              if (successFlag === "Y" && Array.isArray(res.data[1])) {
                const options= res.data[1].map((item)=>({
                  label: item.meaning,
                  value: item.lookup_code
                }))
                setShiftOpenFlag(options);
                setShiftCloseFlag(options);
                setFetchYesOrNoLOV(false);
              } 
            }
          } catch (err) {
            console.log(err);
            setFetchYesOrNoLOV(false);
          }
        };
        fetchYesOrNoLOV();
      }, []);

  // Fetch Processes when the component mounts
  const handleLoadData = async () => {

    const p_param = {
    p_user_id:null,
    p_shift_type_name: shiftTemplateId.label,
    p_process_id: processNameId.value,
    p_auto_shift_open_flag: shiftOpenFlagId.value,
    p_auto_shift_close_flag: shiftCloseFlagId.value,
    p_start_date_active: startDate,
    p_end_date_active: endDate,
    };
    console.log(p_param);
      try {
        setIsLoading(true);
        const response = await loadApi(p_param,"/api/setup/shiftTypes/selRows");
        console.log(response);
        console.log("Fetched Shift Types:", response.data);
        console.log(response.data[0]);
        console.log(response.data[1]);
        if (response.data.length > 0) {
          let successFlag = response.data[0];
          if (successFlag === "Y") {
            toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
            console.log("success=Y");
            setRows(response.data[1]);
            setIsLoading(false);
            setWasDataFetchingSuccessful(false);
          } else {
            //setRows(null);
            setRows([]);
            setIsLoading(false);
            const errorInfo = response.data[2];

            // Set the error message and display the dialog
            setErrorMessage(errorInfo);
            setErrorDialogVisible(true);
            setWasDataFetchingSuccessful(true);
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
          setWasDataFetchingSuccessful(true);
        }

        //setRows(response.data);
      } catch (error) {
        if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        console.log("Request was cancelled by the user.");

        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
        setIsLoading(false);
      } else {
        console.error("Error fetching Machine Names:", error);
      }
      } finally {
      setIsLoading(false);
    }
    };

  const showProduct = (row) => {
    setRow({ ...row });
    setShowProductDialog(true);
  };

  const showDetailProduct = (row) => {
    setDetailRow({ ...row });
    setShowDetailDialog(true);
  };

  const openNew = () => {
    setRow(emptyRow);
    setShiftTypeSelectId({label: "", value: null});
    setProcessSelectId({label: "", value: null});
    setShiftOpenSelectFlagId({label: "", value: ""});
    setShiftCloseSelectFlagId({label: "", value: ""});
    setSubmitted(false);
    setRowDialog(true);
    setDialog("create")
  };

  const hideDialog = () => {
    setSubmitted(false);
    setRowDialog(false);
    setDialog("")
    setShowProductDialog(false);
    setShowDetailDialog(false);
    setErrorDialogVisible(false);
  };

  const formatDateColumn = (dateValue) => {
    return dateValue ? moment.utc(dateValue).format("DD-MMM-YYYY") : null;
  };

  const startDateBodyTemplate = (rowData) => {
    return formatDateColumn(rowData.start_date_active);
  };

  const endDateBodyTemplate = (rowData) => {
    return formatDateColumn(rowData.end_date_active);
  };

  /***
        const formatDateFields = (row, isNew) => {
            const formatDate = (date) => date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : null;
    
            return {
                ...row,
                creation_date: isNew ? formatDate(new Date()) : formatDate(row.creation_date),
                last_update_date: formatDate(new Date()),
                start_date: formatDate(row.start_date),
                end_date: formatDate(row.end_date)
            };
        };
         */

  const saveRow = async () => {
    setSubmitted(true);

    if (row.shift_type_name.trim() && row.auto_shift_open_flag.trim() && row.auto_shift_close_flag.trim()) {
      //      const isNew = !row.process_id;
      //     const formattedRow = formatDateFields(row, isNew);

      let _rows = [...rows];
      let _row = { ...row };

      try {
        if (row.shift_type_id && row.shift_type_id != null && row.shift_type_id != undefined) {
          /*** Update Row */
          const response = await saveApi(row, "/api/setup/shiftTypes/updRow");
          //await axios.put(`http://localhost:5000/api/shiftDetail/${row.row_id}`, formattedRow);
          //             const updatedRows = rows.map((p) => (p.row_id === row.row_id ? formattedRow : p));
          //             setRows(updatedRows);
          console.log("updating");
          console.log(response.data);
          let successFlag = response.data[0];
          if (successFlag === "Y") {
            const index = findIndexById(row.shift_type_id);
            _rows[index] = _row;
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Shift Types Updated",
              life: 3000,
              width: "600px",
            });
          } else {
            let err_msg = response.data[1];
            toast.current.show({
              severity: "error",
              summary: err_msg,
              detail: "Shift Types Not Updated",
              life: 3000,
              width: "600px",
            });
          }
        } else {
          /*** Insert Row */
          const response = await saveApi(row, "/api/setup/shiftTypes/insRow");
          //const response = await axios.post('http://localhost:5000/api/shiftDetail', formattedRow);
          //       formattedRow.row_id = response.data.id;
          //     setRows([...rows, formattedRow]);
          console.log("saving");
          console.log("Response data: ", response.data);
          console.log("Response: ", response);
          let successFlag =
            response.data[0]; /** This contains value of Y or N */
          if (successFlag === "Y") {
            _row.shift_type_id =
              response.data[1]; /** It contains newly created Id */
            _rows.push(_row);
            toast.current.show({
              severity: "success",
              summary: (
                <div style={{ marginright: "200px", width: "600px" }}>
                  Success
                </div>
              ),
              detail: <div style={{ width: "600px" }}>Shift Type Created</div>,
              life: 3000,
              width: "600px",
            });
          } else {
            let err_msg = response.data[2];
            toast.current.show({
              severity: "error",
              summary: <div style={{ width: "600px" }}>{err_msg}</div>,
              detail: <div style={{ width: "600px" }}>{err_msg}</div>,
              life: 3000,
              width: "600px",
            });
          }
        }

        setRows(_rows);
        setRowDialog(false);
        setRow(emptyRow);
      } catch (error) {
        console.error("Error saving Shift Type Name:", error);
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Shift Type Name Save Failed",
          life: 3000,
          width: "600px",
        });
      }
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Please fill in all required fields",
        life: 3000,
        width: "600px",
      });
    }
  };

  const fetchshiftDetail = async (shift_type_id) => {
      setIsLoading1(true);
      setLoadingId(shift_type_id);
      const p_param = {
        p_user_id: null,
        p_shift_type_id: shift_type_id,
      };
      console.log(p_param);
      try {
        const response = await loadApi(p_param,"/api/setup/shiftTypes/selDtlRows"
        );
        console.log("Fetched shift Details:", response.data);
  
        if (response.data.length > 0) {
          const successFlag = response.data[0];
          if (successFlag === "Y") {
            setShiftDetail((prevshiftDetail) => ({
              ...prevshiftDetail,
              [shift_type_id]: response.data[1],
            }));
            setIsLoading1(false);
          } else {
            setShiftDetail((prevshiftDetail) => ({
              ...prevshiftDetail,
              [shift_type_id]: [],
            }));
          }
        } else {
          setShiftDetail((prevshiftDetail) => ({ ...prevshiftDetail, [shift_type_id]: [] }));
          setIsLoading1(false);
        }
      } catch (error) {
        console.error("Error fetching shiftDetail:", error);
      } finally {
        setIsLoading1(false);
        setLoadingId(null);
      }
    };
  
    useEffect(() => {
      const prevExpanded = prevExpanRef.current;
        const newlyExpanded = expandedRowId.filter((id) => !prevExpanded.includes(id))
        newlyExpanded.forEach((shift_type_id) => {
        if(shift_type_id) {
          fetchshiftDetail(shift_type_id);
        }
      });
      prevExpanRef.current = expandedRowId;
    }, [expandedRowId]
  )
  

  const drillDownTemplate = (rowData) => {
      const isExpanded = expandedRowId.includes(rowData.shift_type_id);
  
      return (
        <Button
          icon={isExpanded ? "pi pi-chevron-down" : "pi pi-chevron-right"}
          className={`p-button-rounded p-button-sm ${
            isExpanded ? "p-button-danger" : "p-button-primary"
          }`}
          onClick={() => toggleRowExpansion(rowData.shift_type_id)}
          tooltip="Detail"
          tooltipOptions={{ position: "bottom" }}
          style={{ fontSize: "1rem" }}
        />
      );
    };

    const toggleRowExpansion = (rowId) => {
    setExpandedRowId((prevExpandedRowId) =>
      prevExpandedRowId.includes(rowId)
        ? prevExpandedRowId.filter((id) => id !== rowId)
        : [...prevExpandedRowId, rowId]
    );
  };

  const rowExpansionTemplate = (data) => {
      const shiftDetailData = shiftDetail[data.shift_type_id] || [];
      const exportCSV1 = () => {
        dt1.current.exportCSV();
      };
  
      return (
        <div className="p-3">
          {loadingRowId == data.shift_type_id && (<h6>The data is loading...</h6>)}
          {loadingRowId != data.shift_type_id && (<>
          <div className="header-container">
            <div className="header-container p-1">
              <style>
                {`
                  input::placeholder {
                    font-size: 17px;
                  }
                `}
              </style>
              <span className="p-input-icon-right w-full md:w-auto">
                <InputText
                  type="search"
                  onInput={(e) => setGlobalFilter1(e.target.value)}
                  placeholder="Search..."
                  className="w-full lg:w-auto text-sm p-3"
                  style={{ fontSize: "17px" }}
                />
              </span>
              <Button
                icon="pi pi-upload"
                className="p-button-primary p-button-rounded"
                onClick={exportCSV1}
                tooltip="Export"
                tooltipOptions={{ position: "bottom" }}
                style={{ marginLeft: "20px", marginBottom: "10px" }}
              />
              <span style={{marginLeft: "20px"}}>
                <b>No. of Rows :</b> {shiftDetailData.length}
              </span>
            </div>
          </div>
          <DataTable
            ref={dt1}
            value={shiftDetailData}
            dataKey={shiftDetailData.shift_type_detail_id}
            responsiveLayout="scroll"
            globalFilter={globalFilter1}
          >
            <Column
                body={readBodyTemplate1}
                exportable={false}
                style={{ width: "0.75rem" }}
              ></Column>
            <Column
              field="shift_number"
              header="Shift Number"
              sortable
            ></Column>
            <Column
              field="shift_start_time"
              header="Start Time"
              sortable
            ></Column>
            <Column
              field="shift_end_time"
              header="End Time"
              sortable
            ></Column>
            <Column
              field="shift_end_in_next_day_flag_dsp"
              header="Shift End In Next Day?"
              sortable
            ></Column>
            <Column
              field="auto_shift_open_flag_disp"
              header="Auto Shift Open?"
              sortable
            ></Column>
            <Column field="auto_shift_close_flag_disp" header="Auto Shift Close?" sortable></Column>
            <Column
              field="shift_early_start_allow_mins"
              header="Early Start Allow mins"
              sortable
            ></Column>
            <Column field="shift_early_end_allow_mins" header="Early End Allow mins" sortable></Column>
            <Column
              field="shift_late_end_allow_mins"
              header="Late End Allow mins"
              sortable
            ></Column>
            <Column
              field="start_date_active"
              header="Start Date Active"
              body={startDateBodyTemplate}
              sortable
            ></Column>
            <Column field="end_date_active" header="End Date Active" body={endDateBodyTemplate} sortable></Column>
          </DataTable>
          </>
          )}
        </div>
      );
    };

  const editRow = (row) => {
    setRow({ ...row });
    setShiftTypeSelectId({label: row.shift_type_name, value: row.shift_type_id});
    setProcessSelectId({label: row.process_name, value: row.process_id});
    setShiftOpenSelectFlagId({label: row.auto_shift_open_flag_disp, value: row.auto_shift_open_flag});
    setShiftCloseSelectFlagId({label: row.auto_shift_close_flag_disp, value: row.auto_shift_close_flag});
    setRowDialog(true);
    setDialog("edit")
  };

  const findIndexById = (id) => {
    let index = -1;
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].shift_type_id === id) {
        index = i;
        break;
      }
    }
    return index;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const getLoadingHeaderContents = () => {
    return (
      <React.Fragment>
        <div className="row d-flex justify-content-center m-5">
          <div className="col-auto">
            <div className="card shadow-sm border-primary">
              <div className="card-header bg-primary text-white">
                <h2 className="mb-0">Shift Templates</h2>
              </div>
              <div className="card-body text-center">
                <h3>
                  <i className="fa-duotone fa-fw fa-spin-pulse fa-loader me-3"></i>{" "}
                  The page is loading...
                </h3>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  const getLoadedHeaderContents = () => {
                  return (
                    <React.Fragment>
                      <div className="header-container">
                        <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                        Shift Templates
                        </h2>
                        <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                          <div className="header-container p-1">
                              <style>
                              {`
                                input::placeholder {
                                  font-size: 17px; 
                                }
                              `}
                            </style>
                          {/* <span className="p-input-icon-right w-full md:w-auto"> 
                        <InputText
                          type="search"
                          onInput={(e) => setGlobalFilter(e.target.value)}
                          placeholder="Search..."
                          className="w-full lg:w-auto text-sm p-3"
                          style={{ fontSize: '17px' }} 
                        />
                      </span> */}
                          </div>
                        </h2>
                      </div>
                    </React.Fragment>
                  );
                }


  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _row = { ...row };
    _row[`${name}`] = val;

    setRow(_row);
  };

  const onInputProcessSelectIdChange = (selectedOption, name, id) => {
    if(selectedOption == null) {
      setProcessSelectId({label: "", value: null});
    } else {
    setProcessSelectId(selectedOption);
    }
    const val = selectedOption != null ? selectedOption.value : null;
    const val1 = selectedOption != null ? selectedOption.label : "";

    let _row = { ...row };
    _row[`${id}`] = val;
    _row[`${name}`] = val1;

    setRow(_row);
  };

  const onInputShiftTypeSelectChange = (selectedOption, name, id) => {
    if(selectedOption == null) {
      setShiftTypeSelectId({label: "", value: null});
    } else {
    setShiftTypeSelectId(selectedOption);
    }
    const val = selectedOption != null ? selectedOption.value : null;
    const val1 = selectedOption != null ? selectedOption.label :"";

    let _row = { ...row };
    _row[`${id}`] = val;
    _row[`${name}`] = val1;

    setRow(_row);
  };

  const onInputShiftOpenIdChange = (selectedOption, name, id) => {
    if(selectedOption == null) {
      setShiftOpenSelectFlagId({label: "", value: ""});
    } else {
    setShiftOpenSelectFlagId(selectedOption);
    }
    const val = selectedOption != null ? selectedOption.value : "";
    const val1 = selectedOption != null ? selectedOption.label : "";

    let _row = { ...row };
    _row[`${id}`] = val;
    _row[`${name}`] = val1;

    setRow(_row);
  };

  const onInputNumberChange = (e, name) => {
    const val = (e.target.valueAsNumber) || "";
    let _row = { ...row };
    _row[`${name}`] = val;

    setRow(_row);
  };

  const onInputShiftCloseIdChange = (selectedOption, name, id) => {
    if(selectedOption == null) {
      setShiftCloseSelectFlagId({label: "", value: ""});
    } else {
    setShiftCloseSelectFlagId(selectedOption);
    }
    const val = selectedOption != null ? selectedOption.value : "";
    const val1 = selectedOption != null ? selectedOption.label : "";

    let _row = { ...row };
    _row[`${id}`] = val;
    _row[`${name}`] = val1;

    setRow(_row);
  };

  /***
    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="New" icon="pi pi-plus" className="p-button-success p-mr-2" onClick={openNew} />
            </React.Fragment>
        )
    }

    const headerDontUse = (
        <div className="table-header">
            <h5 className="p-m-0">Manage shiftDetail</h5>
            {/* <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
            </span> * /}
        </div>
    );
    */

  const header = (
    <div
      className="table-header"
      style={{
        display: "flex",
        justifyContent: "space-between",
        height: "3rem",
        alignContent: "center",
      }}
    >
      <div
        style={{
          width: window.innerWidth / 3,
          display: "flex",
          justifyContent: "flex-start",
          marginRight: "110px",
        }}
      >
        <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span>
      </div>
      <div>
        <Button
          // label="New"
          icon="pi pi-plus"
          className="p-button-rounded p-button-success p-mr-2"
          onClick={openNew}
          tooltip="New"
          tooltipOptions={{ position: "bottom" }}
        />
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
          style={{ marginLeft: "20px" }}
        />
      </div>
    </div>
  );

  const actionBodyEditTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-success p-mr-2"
          onClick={() => editRow(rowData)}
          tooltip="Edit"
          tooltipOptions={{ position: "bottom" }}
          // disabled={true}
        />
      </React.Fragment>
    );
  };

  const sDate = row.start_date_active ? moment.utc(row.start_date_active).format("DD-MMM-YYYY") : null;
  const eDate = row.end_date_active ? moment.utc(row.end_date_active).format("DD-MMM-YYYY") : null;

  const readBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

  const readBodyTemplate1 = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showDetailProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

     const CardComponent = ({title, data}) => {
      const rightAlignedLabels = ["Sort Key : "];
    
          return (
            <Card className="card-containers">
              <h5  style={{"fontWeight":"bold"}}> {title} </h5>
              <Divider className="my-2" />
              {data.map((item, index) => (
                <div key={index} className="label-value-pair">
                  <span className="label">{item.label}</span>
                  
                  {item.label &&
                  <span         
                  className={`value-box ${rightAlignedLabels.includes(item.label) ? "align-right": ""}`}>
                    {item.value}</span>
                  }
                  
                </div>
              ))}
            </Card>
          )
        }
  
  const inputRightBoxStyle = {
    textAlign: "right",
     outline: "0.015625rem thin #d3d3d3",
    borderradius: "5px", 
    border: "thin solid #d3d3d3",
    paddingLeft: "6px",
    borderRadius: "4px",
    backgroundColor:"rgb(235, 235, 235)",
    width: "100%",
  }
  const inputDateStyle = {
    outline: "0.015625rem thin #d3d3d3",
    borderradius: "5px", 
    border: "thin solid #d3d3d3",
    paddingLeft: "6px",
    borderRadius: "4px",
    backgroundColor:"rgb(235, 235, 235)",
    width: "100%",
  }
  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    return `${year}-${month}-${day}`
  }

  const handleShiftTemplateId = (selectedOption) => {
    if(selectedOption == null) {
      setShiftTemplateId({label: "", value: null});
    } else {
    setShiftTemplateId(selectedOption);
    }
  }

  const handleProcessNameId = (selectedOption) => {
    if(selectedOption == null) {
      setProcessNameId({label: "", value: null});
    } else {
    setProcessNameId(selectedOption);
    }
  }

  const handleShiftOpenFlagId = (selectedOption) => {
    if(selectedOption == null) {
      setShiftOpenFlagId({label: "", value: ""});
    } else {
    setShiftOpenFlagId(selectedOption);
    }
  }

  const handleShiftCloseFlagId = (selectedOption) => {
    if(selectedOption == null) {
      setShiftCloseFlagId({label: "", value: ""});
    } else {
    setShiftCloseFlagId(selectedOption);
    }
  }

     const getShiftTemplateName = () => (
        <React.Fragment>
      <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
        <label className="form-label">Shift Template Name</label>
         <Select
            // className="form-select"
            id="shiftTemplateId"
            name="shiftTemplates"
            onChange={handleShiftTemplateId}
            options={shiftTemplates}
            value={shiftTemplateId}
            placeholder="Select Machine"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            className="select-dropdown"
            classNamePrefix="select-dropdown"
          />
      </div>
    </React.Fragment>
      );

      const getProcessName = () => (
        <React.Fragment>
      <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
        <label className="form-label">Process Name</label>
         <Select
            // className="form-select"
            id="processNameId"
            name="processNameId"
            onChange={handleProcessNameId}
            options={processName}
            value={processNameId}
            placeholder="Select Machine Group"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            className="select-dropdown"
            classNamePrefix="select-dropdown"
          />
      </div>
    </React.Fragment>
      );

      const getShiftOpen = () => (
        <React.Fragment>
          <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
            <label className="form-label">Auto Shift open?</label>
           <Select
            // className="form-select"
            id="shiftOpenFlagId"
            name="shiftOpenFlagId"
            onChange={handleShiftOpenFlagId}
            options={shiftOpenFlag}
            value={shiftOpenFlagId}
            placeholder="Select Shift Open"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            className="select-dropdown1"
            classNamePrefix="select-dropdown1"
          />
          </div>
        </React.Fragment>
      );

      const getShiftClose = () => (
        <React.Fragment>
          <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
            <label className="form-label">Auto Shift close?</label>
           <Select
            // className="form-select"
            id="shiftCloseFlagId"
            name="shiftCloseFlagId"
            onChange={handleShiftCloseFlagId}
            options={shiftCloseFlag}
            value={shiftCloseFlagId}
            placeholder="Select Shift Close"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            className="select-dropdown1"
            classNamePrefix="select-dropdown1"
          />
          </div>
        </React.Fragment>
      );

      const getStartEndDateControls = () => (
          <React.Fragment>
            <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
              <label className="form-label">Active From</label>
              <div className="input-group date input-wrapper">
              <input
                type="date"
                id="StartDate"
                name="StartDate"
                value={startDate}
                onChange={handleStartDateChange}
                disabled={isLoading}
                className="input-outline1"
              />
              </div>
            </div>
            <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
              <label className="form-label">Active Until</label>
              <div className="input-group date input-wrapper">
              <input
                type="date"
                id="EndDate"
                name="EndDate"
                value={endDate}
                onChange={handleEndDateChange}
                disabled={isLoading}
                className="input-outline1"
              />
              </div>
            </div>
          </React.Fragment>
        );
      
        const handleStartDateChange = (e) => {
          setStartDate(e.target.value);
        };
      
        const handleEndDateChange = (e) => {
          setEndDate(e.target.value);
        };

     const getGoButtonControl = () => (
        <React.Fragment>
          <div className="col-auto d-flex align-items-center justify-content-center ps-2 pe-0" style={{paddingTop:'1.9375rem'}}>
            <button
              type="button"
              className="btn btn-primary load-button"
              id={"chartAreaId"}
              onClick={handleLoadData}
              disabled={isLoading}
            >
               <i
                className={
                  isLoading ? "fa-duotone fa-fw fa-rotate fa-spin" : "fa-duotone fa-fw fa-rotate"
                }
              ></i>
              <span>{isLoading ? "Loading" : "Go"}</span>
            </button>
          </div>
        </React.Fragment>
      );
  return (
    <div>
      <Toast ref={toast} />
    <div className="col mx-2">
        {fetchShiftTemplates && fetchProcess ? getLoadingHeaderContents() : getLoadedHeaderContents()}
        {!fetchShiftTemplates && !fetchProcess && (
        <div className="row">
          <div className="col">
            <div className="row justify-content-center">
              {getShiftTemplateName()}
              {getProcessName()}
              {getShiftOpen()}
              {getShiftClose()}
              {getStartEndDateControls()}
              {getGoButtonControl()}
            </div>
            {!wasDataFetchingSuccessful && (
              <div className="card my-3">
            {/* <div className="text-3xl text-800 font-bold mb-4">Inquire NonWork Type</div> */}
            <DataTable
              ref={dt}
              value={rows}
              selection={selectedRows}
              onSelectionChange={(e) => setSelectedRows(e.value)}
              dataKey="shift_type_id"
              scrollable
              scrollHeight="flex"
              className="custom-datatable-border"
              tableStyle={{ minWidth: "50rem" }}
              paginator
              rows={pecaPageRows}
              rowsPerPageOptions={pecaRowsPerPageOptions}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Machine"
              globalFilter={globalFilter}
              header={header}
              emptyMessage="No Machine found"
              stripedRows
              showGridlines        
              responsiveLayout="scroll"
              expandedRows={expandedRowId.map((shift_type_id) =>
                rows.find((rows) => rows.shift_type_id === shift_type_id)
              )}
              onRowToggle={(e) => {
                const rowId = e.data ? e.data.shift_type_id : null;
                setExpandedRowId((prev) =>
                  prev.includes(rowId)
                    ? prev.filter((shift_type_id) => shift_type_id !== rowId)
                    : [...prev, rowId]
                );
              }}
              rowExpansionTemplate={rowExpansionTemplate}
            >
              {/* <Column
                body={drillDownTemplate}
                style={{ width: "0.75rem", textAlign: "center" }}
              /> */}
              <Column
                body={readBodyTemplate}
                exportable={false}
                style={{ width: "0.75rem" }}
              ></Column>
              <Column
              body={drillDownTemplate}
              style={{ width: "3rem", textAlign: "center" }}
              />
              <Column
                field="shift_type_id"
                header="id"
                sortable="false"
                hidden="true"
                exportable={false}
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="shift_type_name"
                header="Shift Template Name"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="process_name"
                header="Process Name"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="auto_shift_open_flag_disp"
                header="Auto Shift Open?"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="auto_shift_close_flag_disp"
                header="Auto Shift Close?"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="shift_early_start_allow_mins"
                header="Early Start Allow Mins"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="shift_late_start_allow_mins"
                header="Late Start Allow Mins"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="shift_early_end_allow_mins"
                header="Early End Allow Mins"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="shift_late_end_allow_mins"
                header="Late End Allow Mins"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>        
              <Column
                field="start_date_active"
                header="Active Start Date"
                body={startDateBodyTemplate}
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="end_date_active"
                header="Active End Date"
                body={endDateBodyTemplate}
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                body={actionBodyEditTemplate}
                style={{ width: "0.75rem" }}
              ></Column>
            </DataTable>
          </div>
        )}
        </div>
        </div>
        )}
        <Dialog
          visible={rowDialog}
          style={{ width: "1400px" }}
          modal
          className="p-fluid"
          onHide={hideDialog}
        >
          <h4 style={{"fontWeight":"bold"}}> Shift Types </h4>
          <Divider className="my-4" />
          <h5 style={{"fontWeight":"bold"}}>  {dialog === "edit" ? "Update Shift Types" : dialog === "create" ? "Create Shift Types Information" : ""} </h5>
          <Divider className="my-4" />
          <div className="card-wrapper">
          <Card className="card-containers">
            <h5  style={{"fontWeight":"bold"}}> Shift Types Details </h5>
            <Divider className="my-2" />
            <div className="label-value-pair">
            <span className="label" htmlFor="shift_type_id">Shift Types Name : </span>
            <span style={{flexGrow:1}}>
              <Select
            // className="form-select"
            id="shiftTypeSelectId"
            name="shiftTypeSelectId"
            onChange={(selectedOption) => onInputShiftTypeSelectChange(selectedOption, "shift_type_name", "shift_type_id")}
            options={shiftTemplates}
            value={shiftTypeSelectId}
            placeholder="Select Shift Types"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            className="select-dropdown2"
            classNamePrefix="select-dropdown2"
          />
            </span>
            {submitted && row.shift_type_id == null && dialog === "create" && (
              <small className="p-error">Shift Type Name is required.</small>
            )}
          </div>

            <div className="label-value-pair">
            <span className="label" htmlFor="process_id">Process Name : </span>
            <span style={{flexGrow:1}}>
            <Select
            // className="form-select"
            id="processSelectId"
            name="processSelectId"
            onChange={(selectedOption) => onInputProcessSelectIdChange(selectedOption, "process_name", "process_id")}
            options={processName}
            value={processSelectId}
            placeholder="Select Process"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            className="select-dropdown2"
            classNamePrefix="select-dropdown2"
          />
            </span>
          </div>

          <div className="label-value-pair">
            <span className="label" htmlFor="auto_shift_open_flag">Auto Shift Open? </span>
            <span style={{flexGrow:1}}>
            <Select
            // className="form-select"
            id="shiftOpenSelectFlagId"
            name="shiftOpenFlagId"
            onChange={(selectedOption) => onInputShiftOpenIdChange(selectedOption,"auto_shift_open_flag_disp", "auto_shift_open_flag")}
            options={shiftOpenFlag}
            value={shiftOpenSelectFlagId}
            placeholder="Select Auto Shift Open"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            className="select-dropdown2"
            classNamePrefix="select-dropdown2"
          />
            </span>
          </div>

           <div className="label-value-pair">
            <span className="label" htmlFor="auto_shift_close_flag">Auto Shift Close? </span>
            <span style={{flexGrow:1}}>
            <Select
            // className="form-select"
            id="shiftCloseFlagId"
            name="shiftCloseFlagId"
            onChange={(selectedOption) => onInputShiftCloseIdChange(selectedOption,"auto_shift_close_flag_disp", "auto_shift_close_flag")}
            options={shiftCloseFlag}
            value={shiftCloseSelectFlagId}
            placeholder="Select Auto Shift Close"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            className="select-dropdown2"
            classNamePrefix="select-dropdown2"
          />
            </span>
          </div>

          <div className="label-value-pair">
            <span className="label"htmlFor="sort_key">Early Start Allow Mins : </span>
            <span style={{flexGrow:1}}>
           <input
           type="number"
           value={row.shift_early_start_allow_mins}
           onChange={(e) => onInputNumberChange(e, "shift_early_start_allow_mins")}
           style={inputRightBoxStyle}
           />
            </span>
          </div>

          <div className="label-value-pair">
            <span className="label"htmlFor="sort_key">Late Start Allow Mins : </span>
            <span style={{flexGrow:1}}>
           <input
           type="number"
           value={row.shift_late_start_allow_mins}
           onChange={(e) => onInputNumberChange(e, "shift_late_start_allow_mins")}
           style={inputRightBoxStyle}
           />
            </span>
          </div>

          <div className="label-value-pair">
            <span className="label"htmlFor="sort_key">Early End Allow Mins : </span>
            <span style={{flexGrow:1}}>
           <input
           type="number"
           value={row.shift_early_end_allow_mins}
           onChange={(e) => onInputNumberChange(e, "shift_early_end_allow_mins")}
           style={inputRightBoxStyle}
           />
            </span>
          </div>

          <div className="label-value-pair">
            <span className="label"htmlFor="sort_key">Late End Allow Mins : </span>
            <span style={{flexGrow:1}}>
           <input
           type="number"
           value={row.shift_late_end_allow_mins}
           onChange={(e) => onInputNumberChange(e, "shift_late_end_allow_mins")}
           style={inputRightBoxStyle}
           />
            </span>
          </div>

          </Card>
          <Card className="card-containers">
            <h5  style={{"fontWeight":"bold"}}> Active Dates </h5>
            <Divider className="my-2" />
            <div className="label-value-pair">
            <span className="label" htmlFor="start_date_active">Active Start Date : </span>
            <span style={{flexGrow:1}} className="input-wrapper">
            <input
              type="date"
              id="start_date_active"
              defaultValue={formatDateTime(row.start_date_active)}
              onChange={(e) => onInputChange(e, "start_date_active")}
              style={inputDateStyle}
            />
            </span>
          </div>
          <div className="label-value-pair">
            <span className="label" htmlFor="end_date_active">Active End Date : </span>
            <span style={{flexGrow:1}} className="input-wrapper">
            <input
              type="date"
              id="end_date_active"
              defaultValue={formatDateTime(row.end_date_active)}
              onChange={(e) => onInputChange(e, "end_date_active")}
              style={inputDateStyle}
            />
            </span>
          </div>
          </Card>
          </div>
          <div className="btn-container">
          <Button
            label="Cancel"
            icon="pi pi-times"
            className="p-button-text"
            onClick={hideDialog}
            style={{"width":"20%","backgroundColor":"#0d6efd", "color":"white", "borderRadius":"4px", "cursor":"pointer"}}
          />
          <Button
            label="Save"
            icon="pi pi-check"
            className="p-button-text"
            onClick={saveRow}
            style={{"width":"20%","backgroundColor":"#0d6efd", "color":"white", "borderRadius":"4px", "cursor":"pointer"}}
          />
          </div>
        </Dialog>

        <Dialog visible={showproductDialog} style={{ width: '1400px' }} modal className="p-fluid" onHide={hideDialog}>     
                        <h4 style={{"fontWeight":"bold"}}> Shift Template Details </h4>
                        <Divider className="my-4" />
                        <h5 style={{"fontWeight":"bold"}}> View Shift Templates </h5>
                        <Divider className="my-4" />
                        <div className="card-wrapper">
                          <CardComponent
                            title="Shift Template Details"
                            data={[
                              {label:"Shift Type Name : ", value: row.shift_type_name },
                              {label:"Process Name : ", value: row.process_name },
                              {label:"Auto Shift Open? : ", value: row.auto_shift_open_flag_disp},
                              {label:"Auto Shift Close? : ", value: row.auto_shift_close_flag_disp},
                              {label:"Early Start Allow mins : ", value: row.shift_early_start_allow_mins},
                              {label:"Late Start Allow mins : ", value: row.shift_late_start_allow_mins},
                              {label:"Early End Allow mins : ", value: row.shift_early_end_allow_mins},
                              {label:"Late End Allow mins : ", value: row.shift_late_end_allow_mins}
                            ]}
                          />
                          <CardComponent
                            title="Active Dates"
                            data={[
                              {label:"Active Start Date : ", value: sDate },
                              {label:"Active End Date : ", value: eDate },
                            ]}
                          />
                         </div>
                    </Dialog>
          
       <Dialog visible={showDetailDialog} style={{ width: '1400px' }} modal className="p-fluid" onHide={hideDialog}>     
                        <h4 style={{"fontWeight":"bold"}}> Shift Template Details </h4>
                        <Divider className="my-4" />
                        <h5 style={{"fontWeight":"bold"}}> View Shift Templates </h5>
                        <Divider className="my-4" />
                        <div className="card-wrapper">
                          <CardComponent
                            title="Shift Template Details"
                            data={[
                              {label:"Shift Number : ", value: row.shift_number },
                              {label:"Start Time Name : ", value: row.shift_start_time },
                              {label:"Shift End In Next Day? : ", value: row.shift_end_in_next_day_flag_dsp},
                              {label:"Auto Shift Open? : ", value: row.auto_shift_open_flag_disp},
                              {label:"Auto Shift Close? : ", value: row.auto_shift_close_flag_disp},
                              {label:"Early Start Allow mins : ", value: row.shift_early_start_allow_mins},
                              {label:"Late Start Allow mins : ", value: row.shift_late_start_allow_mins},
                              {label:"Early End Allow mins : ", value: row.shift_early_end_allow_mins},
                              {label:"Late End Allow mins : ", value: row.shift_late_end_allow_mins}
                            ]}
                          />
                          <CardComponent
                            title="Active Dates"
                            data={[
                              {label:"Active Start Date : ", value: sDate },
                              {label:"Active End Date : ", value: eDate },
                            ]}
                          />
                         </div>
                    </Dialog>
                    <Dialog 
                        header="API Error" 
                        visible={errorDialogVisible} 
                        style={{ width: '400px' }} 
                        onHide={hideDialog} 
                        footer={
                            <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                        }
                    >    
                     <p>
        
                            {errorMessage}
                        </p>
                    </Dialog>
                    <style jsx>{`
                      .card-wrapper {
                        display: grid;
                        grid-template-columns: repeat(2,1fr);
                        gap: 10px;
                        padding: 5px;
                      }
        
                      .card-containers {
                        display: flex;
                        background-color: #f9f9f9;
                        flex-direction: column;
                        justify-content: flex-start;
                        border: 1px solid #ccc;
                        paddig: 10px;
                        box-shadow: 4px 4px 10px rgba(0,0,0,0.2);
                        height: auto;
                        width: 100%;
                      }
        
                      .label-value-pair {
                        display: flex;
                        flex-direction: row,
                        align-items: flex-start;
                        gap: 5px;
                        margin-bottom: 8px;
                        flex-wrap: wrap;
                      }
        
                      .label {
                        font-weight: bold;
                        white-space: nowrap;
                      }
        
                      .value-box {
                        background-color:rgb(235, 235, 235);
                        padding: 6px 10px;
                        border-radius: 4px;
                        display: block;
                        word-wrap: break-word;
                        overflow-wrap: break-word;
                        flex-grow: 1;
                        min-width: 0;
                      }

                      .align-right {
                        text-align: right;
                        background-color:rgb(235, 235, 235);
                        padding: 6px 10px;
                        border-radius: 4px;
                        display: block;
                        word-wrap: break-word;
                        overflow-wrap: break-word;
                        flex-grow: 1;
                        min-width: 0;
                      }

                      .btn-container {
                      display: flex;
                      justify-content: center;
                      gap:20px;
                      margin-top:20px;
                      }
                    `}
                    </style>
                    </div>
    </div>
  );
};

export default ShiftTypes;
